/*
 * @Author       : kachun
 * @Date         : 2022/8/26 11:22 上午
 * @Description  : 全局异常监听
 */
import Cookies from 'js-cookie'
import { ElMessageBox } from 'element-plus'
import { RESOURCE_FAILED_RELOAD_KEY } from '/@/stores/constant/cacheKey'

export const errorHandler = (err: any) => {
  const isReloaded = Cookies.get(RESOURCE_FAILED_RELOAD_KEY)
  const { message } = err
  // 1. Loading chunk
  const reg1 = /Loading chunk/i
  // 2. Loading CSS chunk
  const reg2 = /Loading CSS chunk/i
  // 3. Failed to load resource
  const reg3 = /Failed to load resource/i
  // 4. load failed with status 404
  const reg4 = /load failed with status 404/
  // 5. Failed to load module script
  const reg5 = /load module script/

  const hasDeployError = (error: any) => reg1.test(String(error)) || reg2.test(String(error)) || reg3.test(String(error)) || reg4.test(String(error)) || reg5.test(String(error))
  // 防止项目重新发布但用户未刷新页面报错
  if (hasDeployError(message) && !isReloaded) {
    ElMessageBox.confirm('检测到系统更新，为确保你的完整体验，请更新系统', {
      title: '提示',
      confirmButtonText: '马上更新',
      type: 'warning',
      showCancelButton: false,
      showClose: false,
      center: true,
      closeOnClickModal: false,
      closeOnPressEscape: false
    }).then(() => {
      // 5分钟内不重复刷新
      const inFiveMinutes = new Date(new Date().getTime() + 5 * 60 * 1000)
      Cookies.set(RESOURCE_FAILED_RELOAD_KEY, '1', {
        expires: inFiveMinutes
      })
      window.location.replace(window.location.href)
    })
  }
}
